import React from 'react';

interface ErrorBoundaryState {
  hasError: boolean;
}

/**
 * Last-resort safety net: without this, any uncaught error thrown during a
 * React render/effect commit (e.g. a chat subscribe racing the socket
 * connection) unmounts the entire app to a blank screen with no recovery.
 */
export class ErrorBoundary extends React.Component<
  React.PropsWithChildren,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo): void {
    console.error('[ErrorBoundary] Uncaught render error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            height: '100vh',
            background: '#101316',
            color: '#e8f0f8',
            fontFamily: "'Inter', system-ui, sans-serif",
            textAlign: 'center',
            padding: '24px',
          }}
        >
          <div style={{ fontSize: '20px', fontWeight: 600 }}>
            Something went wrong.
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 24px',
              fontSize: '16px',
              borderRadius: '8px',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
